import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AthleteLayout from "../common/AthleteLayout";
import { AthleteHeader } from "../common/AthleteHeader";
import { useAthleteAuthContext } from "../login/useAthleteAuthContext";

export const AthleteFreeWarmupRoutinePhase = () => {
  const navigate = useNavigate();

  const [phases] = useState([
    { phase_id: "1", title: "Stretching" },
    { phase_id: "2", title: "Mobility" },
    { phase_id: "3", title: "Activation" },
  ]); // Static phases data

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showPopup, setShowPopup] = useState(false); // Popup state

  // Function to handle date change
  const changeDate = (days) => {
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() + days);
      return newDate;
    });
  };

  // Format the date for display
  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
    });
  };

  const handlePhaseClick = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const handleFreeSpeedClick = () => {
    navigate("/athlete/free-speed-workout");
  };

  return (
    <AthleteLayout>
      <div className="h-full flex flex-col bg-white">
        <div className="flex-1 overflow-y-auto">
          <div>
            <AthleteHeader />
          </div>
          {/* <div className="py-3 flex flex-row justify-center items-center gap-10">
            <ArrowL onClick={() => changeDate(-1)} />
            <p className="text-black text-xl">
              {formatDate(selectedDate)}
            </p>
            <ArrowG onClick={() => changeDate(1)} />
          </div> */}

          <div className="w-full max-w-2xl mx-auto">
            <div className="py-3">
              <div className="px-5 mb-4">
                <div className="bg-[#f5f4f4] rounded-2xl flex justify-between gap-8 px-4 py-4">
                  <button className="text-black text-sm xs:text-base">
                    Warmup 
                  </button>
                  <button
                    onClick={() => handleFreeSpeedClick()}
                    className="text-lightSmock text-sm xs:text-base"
                  >
                     Workout
                  </button>
                </div>
              </div>

              <div className="space-y-[15px] px-5">
                {phases.map((item) => (
                  <button
                    onClick={handlePhaseClick}
                    key={item.phase_id}
                    className="w-full p-[14px] text-black text-sm font-medium border border-black/90 bg-transparent rounded-xl hover:bg-grayish/10 transition text-start"
                  >
                    {item.title}
                  </button>
                ))}
              </div>
            </div>

            {showPopup && (
              <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center p-3 z-50">
                <div className="bg-white p-4 xs:p-6 rounded-lg shadow-lg max-w-sm w-full text-center">
                  <h2 className="text-black text-xl mb-3">
                    Your Training Starts Here.
                  </h2>
                  <p className="text-black font-medium mb-6">
                    Upgrade to an AMAX Remote membership and receive fully
                    personalized workouts every week.
                  </p>
                  <div className="flex justify-center gap-4">
                    <button
                      onClick={() => navigate("/athlete/membership")}
                      className="bg-black text-white font-medium text-xs xs:text-sm px-4 py-2 rounded hover:bg-black/70 transition"
                    >
                      View Memberships
                    </button>
                    <button
                      onClick={closePopup}
                      className="border border-gray-400 text-grayish font-medium text-xs xs:text-sm px-4 py-2 rounded hover:bg-grayish/10 transition"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </AthleteLayout>
  );
};

const ArrowG = ({ onClick }) => {
  return (
    <svg
      onClick={onClick}
      className="hover:opacity-50 cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M1 13L7 7L0.999999 1"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ArrowL = ({ onClick }) => {
  return (
    <svg
      onClick={onClick}
      className="hover:opacity-50 rotate-180 cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M1 13L7 7L0.999999 1"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
